import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ba9af39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "estimate-revision-summary tw-flex tw-flex-col tw-justify-between tw-gap-4 tw-items-start tw-w-full tw-h-full" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-gap-4 tw-items-start tw-w-full" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-w-full tw-justify-start tw-gap-2" }
const _hoisted_4 = { class: "estimate-revision-summary__phase-content tw-h-full tw-w-full tw-flex tw-flex-col tw-gap-4 tw-max-h-[370px] tw-overflow-auto" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-7 tw-w-full" }

import { computed, reactive, ref } from "vue";
import { useStore } from "vuex";
import Card from "@/core/components/ui/general/Card.vue";
import Text from "@/core/components/ui/general/Text.vue";
import SiteVisitRequestDialog from "@/core/uni-components/SiteVisitRequestDialog.vue";
import EstimateSummaryData from "@/modules/jobs/components/estimates/EstimateSummaryData.vue";
import Button from "@/core/components/ui/general/Button.vue";
import EstimateTotal from "@/modules/jobs/components/estimates/EstimateTotal.vue";
import SelectDepositModal from "@/modules/jobs/components/modal/SelectDepositModal.vue";
import SubmitEstimateConfirmationModal from "@/modules/jobs/components/modal/SubmitEstimateConfirmationModal.vue";
import AcceptEstimateModal from "@/modules/jobs/components/modal/AcceptEstimateModal.vue";
import ServiceAgreementModal from "@/modules/jobs/components/modal/ServiceAgreementModal.vue";
import ConfirmJobModal from "@/modules/jobs/components/modal/ConfirmJobModal.vue";
import AddGrantModal from "@/modules/jobs/components/modal/AddGrantModal.vue";
import SmallPhaseItem from "@/modules/jobs/components/estimates/SmallPhaseItem.vue";
import InfoIcon from "@/core/components/icons/InfoIcon.vue";
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";
import projectEstimationService from "@/core/services/project-estimation.service";
import {
  AgreeTermsConsumerDisclosure,
  EstimatePhaseStatus,
  EstimateTypeForDeposit,
} from "@/core/enums/estimateEnum";
import { ElMessage } from "element-plus";
import { USER_STORE } from "@/store/modules/user";
import { JOBS_STORE } from "@/store/modules/jobs";
import { WORKSTATION } from "@/store/modules/workstation";
import {
  getCurrentConTractorPhases,
  getSubContractorPhases,
} from "@/core/utils/common";
import FinalEstimateSubmitLoadingModal from "../modal/FinalEstimateSubmitLoadingModal.vue";
import ConfirmRaiseProject from "../modal/ConfirmRaiseProject.vue";
import { PropertyWorkflowTypeEnum } from "@/core/enums/PropertiesEnum";
import projectService from "@/core/services/project.service";
import { ProjectMetaDataStatusEnum } from "@/core/enums";
import { PROJECT_STORE } from "@/store/modules/project";
import { JOBS_ROUTE } from "../../routes";
import { useRouter } from "vue-router";
import RequestSiteVisitModal from "@/core/components/modals/projects/RequestSiteVisitModal.vue";
import RequestSiteVisitFormModal from "@/core/components/modals/projects/RequestSiteVisitFormModal.vue";
import SuccessSiteVisitRequestModal from "@/core/components/modals/projects/SuccessSiteVisitRequestModal.vue";
import EarnCreditsModal from "@/core/components/modals/projects/EarnCreditsModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EstimateSummaryCompareCard',
  props: {
  project: Object,
  projectEstimateId: Number,
  isProperty: Boolean,
  isHistoricalProject: {
    type: Boolean,
    default: false,
  },
  isDIYProjectType: {
    type: Boolean,
    default: false,
  },
  isChangeRequest: {
    type: Boolean,
    default: false,
  },
  formData: {
    type: Object,
  },
  estimateForm: {
    type: Object,
  },
  highlightChanges: {
    type: Boolean,
  },
  estimateResponseData: {
    type: Object,
  },
},
  emits: [],
  setup(__props, { emit: __emit }) {

const store = useStore();
const router = useRouter();
const emits = __emit;
const props = __props;

const user = computed(() => store.getters[`${USER_STORE}/user`]);
const grantLabel = computed(() => {
  return !props.formData.grantType ? "Add grant" : "Edit grant";
});

const isOpenRaiseProjectModal = ref(false);

// const formData = computed(
//   () => store.getters[`${JOB_TEMPLATE_STORE}/formData`]
// );
const isFormError = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/getFromErrors`]
);
const IsFinalEstimateSubmitted = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/IsFinalEstimateSubmitted`]
);

const totalSubTotal = computed(() => {
  const sum = props.estimateForm.projectStages.reduce(
    (sum: number, phase: any) => {
      const roundedSubTotal = parseFloat(phase.subTotal);
      return sum + roundedSubTotal;
    },
    0
  );
  return Math.round(sum * 100) / 100;
});

const totalVat = computed(() => {
  if (props.isHistoricalProject) return 0;
  const sum = props.estimateForm.projectStages.reduce(
    (sum: number, phase: any, index: number) => {
      const roundedTotalVat = phase.subTotal * phase.vat;
      return sum + roundedTotalVat;
    },
    0
  );
  return Math.round(sum * 100) / 100;
});

const serviceCharges = computed(() => {
  if (props.isHistoricalProject) return 0;
  const initialProjectCharge = 5;
  const serviceFeePercentage = 0.03; // per phase 3 % charge
  let totalWithServiceFee = props.estimateForm.projectStages.reduce(
    (sum: number, phase: any) => {
      const roundedTotalWithServiceFee = phase.subTotal * serviceFeePercentage;
      return sum + roundedTotalWithServiceFee;
    },
    0
  );

  totalWithServiceFee += initialProjectCharge;
  return Math.round(totalWithServiceFee * 100) / 100;
});

// defineExpose({
//   // onSiteVisitRequest,
// });

const state = reactive({
  showSelectDepositModal: false,
  showSubmitEstimateConfirmationModal: false,
  showAcceptEstimateModal: false,
  showServiceAgreementModal: false,
  showConfirmJobModal: false,
  showAddGrandModal: false,
  showRequestSiteVisitModal: false,
});

const projectDetails = computed(
  () => store.getters[`${JOBS_STORE}/getJobDetails`]
);

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const onSubmitEstimate = async () => {
  const isValid = await store.dispatch(`${JOB_TEMPLATE_STORE}/validateForm`);
  if (
    isValid.flag &&
    !isFormError.value.startDate &&
    !isFormError.value.validationError
  ) {
    return;
  } else {
    if (isFormError.value.subTotalValidError) {
      ElMessage.error(`The calculated amount for phase is negative.`);
      return;
    }

    ElMessage.error(
      isFormError.value.validationError
        ? `validation failed`
        : isValid.errorMessage
    );
  }
};
const updateProjectEstimation = () => {
  return;
};

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(Card, { class: "!tw-min-h-[440px] tw-p-4 tw-box-border !tw-border !tw-border-solid !tw-border-[#dfdfdf] !tw-bg-[#f8fbfd]" }, {
    content: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Text, {
              variant: "h6",
              whiteSpace: "nowrap"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.isHistoricalProject ? "Cost Summary" : "Your Estimate Summary"), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_v_tooltip, {
                "max-width": "242px",
                activator: "parent",
                location: "top",
                class: "estimate_tooltip tw-cursor-pointer"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.isHistoricalProject ? "Cost Summary" : "Your Estimate Summary"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_icon, {
                icon: "mdi-information-slab-circle-outline mdi !tw-text-[16px]",
                color: "#80829F"
              })
            ])
          ]),
          _createVNode(EstimateSummaryData, {
            isReadOnly: true,
            selectedEstimate: __props.estimateResponseData
          }, null, 8, ["selectedEstimate"]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.estimateForm.projectStages, (estimate, index) => {
              return (_openBlock(), _createBlock(SmallPhaseItem, {
                class: "historic-phase-content",
                estimate: estimate,
                phaseIndex: index,
                isHistoricalProject: __props.isHistoricalProject,
                key: index
              }, null, 8, ["estimate", "phaseIndex", "isHistoricalProject"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(EstimateTotal, {
            isChangeRequest: __props.isChangeRequest,
            isProperty: __props.isProperty,
            totalSubTotal: totalSubTotal.value,
            totalVat: totalVat.value,
            serviceCharges: serviceCharges.value,
            isDIYProjectType: __props.isDIYProjectType,
            isShowSubmitBtn: false,
            onOnSubmit: onSubmitEstimate,
            onOnUpdateEstimation: updateProjectEstimation
          }, null, 8, ["isChangeRequest", "isProperty", "totalSubTotal", "totalVat", "serviceCharges", "isDIYProjectType"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})